import styled, { css } from 'styled-components'
import { mobileBreakpoint, tabletBreakpoint, desktopBreakpoint } from 'react-components'
import { Section as BaseSection } from '../common/styles'

export const Section = styled(BaseSection)(
    ({ theme }) => css`
        @media only screen and (max-width: ${desktopBreakpoint.min}px) {
            padding: ${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.xSmall};
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            display: ${theme.style.display.flex};
            flex-direction: ${theme.style.flexDirection.row};
            gap: ${theme.spacing.medium};
            align-items: flex-start;
        }
    `,
)

export const BannerContainer = styled.div<{ $adLoaded?: boolean }>(
    ({ theme }) => css`
        position: relative;
        width: 100%;
        max-width: 79.75rem;
        height: 15.625rem;
        border-radius: ${theme.typography.border.radius.large};
        overflow: hidden;
        cursor: pointer;
        border: 1px solid #d3d3d3;

        @media only screen and (max-width: ${mobileBreakpoint.max}px) {
            min-height: 25rem;
            height: auto;
        }

        @media only screen and (min-width: ${tabletBreakpoint.min}px) and (max-width: ${tabletBreakpoint.max}px) {
            min-height: 31.25rem;
            height: auto;
        }

        a {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 2;
        }
    `,
)

export const BannerPicture = styled.div(
    ({ theme }) => css`
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: block;

        img {
            border-radius: ${theme.typography.border.radius.large};
            object-fit: contain;

            @media only screen and (max-width: ${tabletBreakpoint.max}px) {
                object-fit: fill;
            }
        }
    `,
)

export const BannerContent = styled.div(
    () => css`
        position: absolute;
        top: 0;
        left: 0;
        padding: 2rem;
        height: 100%;
        width: 60%;
        z-index: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: flex-start;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) and (max-width: ${tabletBreakpoint.max}px) {
            width: 60%;
            max-width: 31.25rem;
            justify-content: flex-start;
            gap: 1rem;
        }

        @media only screen and (max-width: ${mobileBreakpoint.max}px) {
            width: 100%;
            top: auto;
            bottom: 2rem;
            right: 0;
            left: 0;
            height: 50%;
            padding: 1rem;
            gap: 1rem;
            align-items: inherit;
        }
    `,
)

export const BannerHeading = styled.h2<{ $color?: string }>(
    ({ theme, $color }) => css`
        font-size: ${theme.typography.font.size.xLarge};
        font-weight: ${theme.typography.font.weight.bold};
        margin: 0;
        font-family: ${theme.typography.font.family.lato};
        line-height: 1;
        color: ${$color || theme.colors.tfwBlack87};

        @media only screen and (min-width: ${tabletBreakpoint.min}px) and (max-width: ${tabletBreakpoint.max}px) {
            font-size: 2rem;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            font-size: 2rem;
        }
    `,
)

export const BannerDescription = styled.p<{ $color?: string }>(
    ({ theme, $color }) => css`
        font-size: ${theme.typography.font.size.medium};
        font-weight: ${theme.typography.font.weight.normal};
        line-height: 1;
        color: ${$color || theme.colors.tfwBlack87};
        margin: 0;
        font-family: ${theme.typography.font.family.lato};

        @media only screen and (min-width: ${tabletBreakpoint.min}px) and (max-width: ${tabletBreakpoint.max}px) {
            font-size: ${theme.typography.font.size.large};
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            font-size: ${theme.typography.font.size.medium};
        }
    `,
)

export const BannerButton = styled.button<{ $color?: string }>(
    ({ theme }) => css`
        background-color: ${theme.colors.tfwYellow};
        color: ${theme.colors.tfwBlack87};
        border: none;
        padding: 1rem 2rem;
        font-size: ${theme.typography.font.size.medium};
        font-weight: ${theme.typography.font.weight.normal};
        font-family: ${theme.typography.font.family.lato};
        border-radius: 0.5rem;
        cursor: pointer;
        transition: all 0.3s ease;
        position: relative;
        z-index: 10;
        display: inline-block;
        width: auto;
        white-space: nowrap;

        &:hover {
            background-color: ${theme.colors.tfwYellowHover};
            transform: translateY(-0.125rem);
            box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.15);
        }

        &:active {
            transform: translateY(0);
        }

        @media only screen and (min-width: ${tabletBreakpoint.min}px) and (max-width: ${tabletBreakpoint.max}px) {
            padding: 1rem 2rem;
            font-size: ${theme.typography.font.size.large};
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            padding: 1rem 2rem;
            font-size: ${theme.typography.font.size.medium};
        }
    `,
)

export const AdContainer = styled.div(
    () => css`
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 300px;
        width: 300px;
        min-height: 250px;
        flex-shrink: 0;

        @media only screen and (max-width: ${desktopBreakpoint.min}px) {
            width: 100%;
        }
    `,
)

export const AdSlot = styled.div(
    () => css`
        width: 300px;
        height: 250px;
        display: block;

        @media only screen and (max-width: ${desktopBreakpoint.min}px) {
            width: 100%;
            min-width: 300px;
        }
    `,
)
